// extracted by mini-css-extract-plugin
export default {"indicator":"ProctorIndicator_indicator__ypuuf","dot":"ProctorIndicator_dot__Ebe2p","blink":"ProctorIndicator_blink__LkdB4","label":"ProctorIndicator_label__v0Wh8"};